export const BEHAVIORS = {
    SHOW: 'SHOW',
    RESET: 'RESET',
    DISABLED: 'DISABLED',
    READONLY: 'READONLY',
}

export default {
    BEHAVIORS,
}
